import React from 'react';
import './assests/css/style.css';
import { useEffect, useState } from 'react';
import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import imgurl from './assests/images/imgurl';
import i18next from 'i18next';

function CameraPreview() {

    return (
        <div className='camerapreview'>

            <ArrowBackIosNewOutlinedIcon className='arrowback' />
            <div className='instructiontext'>
                <img src={imgurl.selfie} alt="Selfie" />
                <p>{i18next.t("Hold your device straight in front,at eye level.")}</p>
            </div>

            <div className='camerapreviewicons'>
                <div>
                    <AddPhotoAlternateOutlinedIcon />
                </div>

                <div className='cameraoutline'>
                    <AddAPhotoOutlinedIcon />
                </div>

                <div>
                    <AutorenewOutlinedIcon />
                </div>
            </div>
        </div>
    )

}

export default CameraPreview;